import { norm } from "../../../../functions/functions";
import MomioGeneral from "./momioGeneral";
import { useMomiosData } from "../../../../hooks/useMomiosData";

/**
 * Componente contenedor de momios para eventos deportivos
 * Muestra los tres momios principales: local, empate y visitante
 * Selecciona automáticamente entre Strendus y Caliente según configuración
 */
export default function MomiosFutComponent({ isFinOrError, item = {}, isStrendus }) {
  // Hook personalizado para manejar datos de momios
  const { getAllMomios } = useMomiosData(item, isStrendus);
  
  // Obtener todos los momios y aplicar normalización a URLs
  const momios = getAllMomios();
  const leftMomio = { ...momios.left, url: norm(momios.left.url) };
  const midMomio = { ...momios.middle, url: norm(momios.middle.url) };
  const rightMomio = { ...momios.right, url: norm(momios.right.url) };

  /**
   * Configuración de momios con sus propiedades
   */
  const momiosConfig = [
    { 
      ...leftMomio, 
      isMayor: true, 
      ariaLabel: 'Momio equipo local' 
    },
    { 
      ...midMomio, 
      className: !midMomio.url ? 'card-general-momio-middle' : '',
      ariaLabel: 'Momio empate',
      shouldRender: midMomio.value && midMomio.url
    },
    { 
      ...rightMomio, 
      isMayor: true, 
      ariaLabel: 'Momio equipo visitante' 
    }
  ];

  return (
    <div
      className={isFinOrError ? "card-general-momios-none" : "card-general-momios-visible"}
      role="group"
      aria-label="Momios de apuestas"
    >
      {momiosConfig.map((momio, index) => {
        // El momio del medio es condicional
        if (index === 1 && !momio.shouldRender) return null;
        
        return (
          <MomioGeneral
            key={index}
            url={momio.url}
            value={momio.value}
            isMayor={momio.isMayor}
            className={momio.className}
          />
        );
      })}
    </div>
  );
}